import React, { useMemo } from "react";
// material
import {
  alpha,
  ThemeProvider,
  createTheme,
  useTheme,
} from "@mui/material/styles";
//
import componentsOverride from "../theme/overrides";
import { CustomTheme } from "../types";
import palette from "../theme/palette";

type Props = {
  children?: React.ReactNode;
};

export default function ThemePrimaryColor({ children }: Props) {
  const defaultTheme = useTheme<CustomTheme>();

  const themeOptions = useMemo(
    () => ({
      ...defaultTheme,
      palette: {
        ...defaultTheme.palette,
        primary: palette.light.primary,
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(palette.light.primary.main, 0.24)}`,
      },
    }),
    [defaultTheme]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
